export default "__VITE_ASSET__CgazFudR__"